var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9646 3.91752e-05V4.55461C19.0001 4.55461 21.9113 5.76046 24.0577 7.9069C26.2042 10.0533 27.41 12.9645 27.41 16C24.3755 15.9969 21.4661 14.7901 19.3203 12.6443C17.1746 10.4985 15.9677 7.58917 15.9646 4.55461H11.4218C11.4237 8.63336 12.9833 12.5574 15.7817 15.5247C18.5802 18.492 22.4062 20.2786 26.4779 20.5192C25.4366 22.9388 23.5927 24.9251 21.2572 26.1432C18.9216 27.3612 16.2374 27.7364 13.6574 27.2054C11.0774 26.6745 8.75953 25.2698 7.09479 23.2285C5.43004 21.1872 4.52034 18.6341 4.51917 16H0C7.74828e-06 19.166 0.939287 22.2609 2.69896 24.8928C4.45863 27.5248 6.95958 29.5755 9.88526 30.7855C12.8109 31.9954 16.0298 32.3102 19.1345 31.6899C22.2391 31.0697 25.09 29.5423 27.3262 27.3012C29.5624 25.06 31.0835 22.2057 31.6969 19.0997C32.3102 15.9937 31.9883 12.7755 30.7719 9.85253C29.5554 6.92954 27.4992 4.43314 24.8633 2.6793C22.2275 0.925461 19.1306 -0.00696526 15.9646 3.91752e-05Z",
    fill: "#8508E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWppLogo);
export default __webpack_public_path__ + "static/media/wpp-logo.d4410a4f02cde492b54468cacd7fd17f.svg";
export { ForwardRef as ReactComponent };